import request from "@/utils/request";

const obj = {
  agentGetAllMemberCarByPage(params, pageNum = 1, size = 10) {
    return request.get(
      `/device/memberCar/agentGetAllMemberCarByPage?pageNum=${pageNum}&size=${size}`,
      {
        params: params,
      }
    );
  },
  agentGetCarOfNeedCheckByPage(params) {
    return request.get(`/device/memberCar/agentGetCarOfNeedCheckByPage`, {
      params,
    });
  },
  agentCheckCar(id) {
    return request.post(`/device/memberCar/agentCheckCar/${id}`);
  },
  agentDisableCar(id) {
    return request.post(`/device/memberCar/agentDisableCar/${id}`);
  },
  agentEnableCar(id) {
    return request.post(`/device/memberCar/agentEnableCar/${id}`);
  },
  agentRejectCar(id) {
    return request.post(`/device/memberCar/agentRejectCar/${id}`);
  },
  agentCreateCar(data) {
    return request.post(`/device/memberCar/agentCreateCar`, data);
  },
};
export default obj;
